<template>
    <div>
        <el-form v-if="form" :inline="true" :size="form.size" @submit.native.prevent="query">
          <template v-if="form.tools">
            <template v-for="(tool, i) in form.tools">
              <el-form-item :key="'tool' + i" v-if="tool.click">
                <el-button :icon="tool.icon" @click="tool.click">
                  {{tool.label}}
                </el-button>
              </el-form-item>
            </template>
          </template>
            <template v-if="formConfigs.length > 0">
                <template v-if="formConfigs.length === 1 && formConfigs[0].type === 'input'">
                    <el-form-item>
                        <el-input :placeholder="formConfigs[0].label" v-model="formConfigs[0].value" clearable @clear="query" style="width: 360px">
                            <el-button slot="append" icon="el-icon-search" native-type="submit"></el-button>
                        </el-input>
                    </el-form-item>
                </template>
                <template v-else>
                    <form-item :config="config" v-for="(config, i) in formConfigs" :key="'c' + i"></form-item>

                    <el-button type="primary" native-type="submit">查询</el-button>
                    <el-button @click="clear">重置</el-button>
                </template>
            </template>
        </el-form>
        <el-table :data="rows" :highlight-current-row="table.radio" :default-sort="table.defaultSort"
                  @selection-change="selectionChange" @current-change="selectionChange" @sort-change="sortChange">
            <el-table-column type="selection" width="55" v-if="table.checkbox"></el-table-column>
            <el-table-column type="expand" v-if="table.expand">
                <template #default="{row}">
                    <slot name="expand" v-bind:row="row"></slot>
                </template>
            </el-table-column>
            <el-table-column :key="'col' + i" v-for="(column, i) in table.columns"
                             :prop="column['name']" :label="column.label" :width="column.width"
                             :sortable="column.sortable ? 'custom' : false">
                <template #default="{row, column}">
                    <slot name="tools" v-bind:row="row" v-if="column.property === 'tool'"></slot>
                    <slot v-bind:row="row" v-bind:property="column.property" v-else>
                        <template v-if="isPrimaryColumn(column.property)">
                            <el-link type="primary" :underline="false" @click="doUpdate(row, column.property)">
                                {{getColumnVal(row, column.property)}}
                            </el-link>
                        </template>
                        <template v-else>
                            {{getColumnVal(row, column.property)}}
                        </template>
                    </slot>
                </template>
            </el-table-column>
            <el-table-column label="操作" :width="toolWidth" v-if="table.tools">
                <template #default="{row}">
                    <slot name="tools" v-bind:row="row">
                        <template v-for="(tool, i) in table.tools">
                            <el-tooltip :key="'t' + i" :content="tool.content" placement="top" v-if="tool.icon">
                                <el-button type="text" :icon="tool.icon" size="small" @click="tool.click(row)"></el-button>
                            </el-tooltip>
                            <el-button :key="'t' + i" v-else type="text" size="small" @click="tool.click(row)">{{tool.content}}</el-button>
                        </template>
                        <el-tooltip content="删除" placement="top" v-if="table.disableDelete !== true && !$root.isOperation">
                            <el-button type="text" icon="el-icon-delete" size="small" @click="toDel(row)"></el-button>
                        </el-tooltip>
                    </slot>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="load"
                @current-change="load"
                :page-sizes="[10, 15, 30, 50]"
                :current-page.sync="page"
                :page-size.sync="limit"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
</template>

<script>
    import FormItem from '@/components/FormItem'

    export default {
        components: {
            FormItem
        },
        props: ["form", "table"],
        data() {
            return {
                formDrawer: false,
                total: 0,
                rows: [],
                page: 1,
                limit: 10,
                sorts: "",
                orders: ""
            }
        },
        mounted() {
            if (this.table.defaultSort) {
                this.sorts = this.table.defaultSort['prop'];
                this.orders = this.table.defaultSort['order'];
            }
            this.query();
        },
        watch: {
            "$route.query"(query) {
                if (Object.keys(query).length === 0) {
                    this.clear();
                }
            }
        },
        computed: {
            formConfigs() {
                let configs = [];
                if (this.form && this.form.configs) {
                    this.form.configs.forEach(config => {
                        if (config.type === "hidden") {
                            return true;
                        }

                        configs.push(config);
                    });
                }
                return configs;
            },
            toolWidth() {
                if (this.table.tools.length < 1) {
                    return 50;
                }
                return 50 + this.table.tools.length * 25;
            }
        },
        methods: {
            getFormRules() {
                if (!this.form || !this.form.configs) {
                    return [];
                }
                let customerFieldIndex = -1;
                let businessFieldIndex = -1;
                let rules = [];
                let i = -1;
                this.form.configs.forEach(config => {
                    let op = config.op ? config.op : "equal";
                    let val = config.value;
                    if (val === "" || val === null || val === undefined || (val !== 0 && val.length === 0)) {
                        return;
                    }

                    i++;
                    rules.push({"field": config.name, "op": op, "value": val});
                    if (config.name === 'customer') {
                        customerFieldIndex = i;
                    } else if (config.name === 'business') {
                        businessFieldIndex = i;
                    }
                });

                if (businessFieldIndex > -1) {
                    rules[businessFieldIndex]['field'] = "code";
                    if (customerFieldIndex > -1) {
                        rules.splice(customerFieldIndex, 1);
                    }
                } else if (customerFieldIndex > -1) {
                    rules[customerFieldIndex]['field'] = "code";
                    rules[customerFieldIndex]['op'] = "beginwith";
                }
                return rules;
            },
            isPrimaryColumn(name) {
                if (this.table.primaryColumns) {
                    let result = false;
                    this.table.primaryColumns.forEach(column => {
                        if (column.name === name) {
                            result = true;
                            return false;
                        }
                    });
                    return result;
                }

                return name === "name";
            },
            getColumnVal(row, prop) {
                let val = row[prop];
                if (val === null || val === undefined) {
                    return "";
                }
                if (val['text']) {
                    return val['text'];
                } else {
                    return val;
                }
            },
            query() {
                this.formDrawer = false;
                this.page = 1;
                this.load();
            },
            clear() {
                if (this.form && this.form.configs) {
                    this.form.configs.forEach(config => {
                        if (config.type !== "hidden") {
                            config.value = null;
                        }
                    });
                }
                this.query();
            },
            getQueryInfo() {
                let queryInfo = {
                    limit: this.limit,
                    offset: (this.page - 1) * this.limit,
                    rules: this.getFormRules()
                };

                if (queryInfo.rules.length < 1) {
                    delete queryInfo['rules'];
                }
                if (this.sorts) {
                    queryInfo['sorts'] = [this.sorts];
                    queryInfo['orders'] = [this.orders ? this.orders.substring(0, this.orders.length - 6) : "desc"];
                } else {
                    // 设置默认排序
                    this.table.columns.forEach(column => {
                        if (column.name === "createTime") {
                            queryInfo['sorts'] = ["createTime"];
                            queryInfo['orders'] = ["desc"];
                            return false;
                        }
                    });
                }
                return queryInfo;
            },
            load() {
                let queryInfo = this.getQueryInfo();

                const vue = this;
                if (this.table.methods && this.table.methods.query) {
                    this.table.methods.query(queryInfo).then(response => {
                        vue.total = response.total;
                        vue.rows = response.rows;
                    });
                } else {
                    this.$axios.post(this.table.urlPrefix + '/paging', queryInfo).then(response => {
                        vue.total = response.total;
                        vue.rows = response.rows;
                    });
                }
            },
            sortChange(data) {
                this.sorts = data['prop'];
                this.orders = data['order'];
                this.load();
            },
            selectionChange(selections) {
                this.$emit("selection-change", selections);
            },
            toDel(row) {
                this.$confirm("是否进行删除操作？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    const vue = this;
                    this.$axios.get(this.table.urlPrefix + '/remove/' + row.id).then(function (response) {
                        if (response.success) {
                            vue.$message.success("删除成功！");
                            vue.load();
                        } else {
                            vue.$message.error(response.message);
                        }
                    })
                });
            },
            doUpdate(row, name) {
                let callback;
                if (this.table.primaryColumns) {
                    this.table.primaryColumns.forEach(column => {
                        if (column.name === name) {
                            callback = column['method'];
                            return false;
                        }
                    });
                }

                if (callback) {
                    callback(row);
                } else {
                    this.$router.push(this.table.urlPrefix + "/" + row.id);
                }
            }
        }
    }
</script>